import { deepCopy } from "@/helpers";
import { TransportCompanyProps } from "@/types";

export const formatDataForUpdate = (
  transportCompany?: TransportCompanyProps,
  isImporter = false
) => {
  if (!transportCompany) return {};
  const transportCompanyCopy = deepCopy(transportCompany);

  delete transportCompanyCopy.createdAt;
  delete transportCompanyCopy.updatedAt;
  delete transportCompanyCopy.logisticRoutes;

  transportCompanyCopy.type = isImporter
    ? "import_company"
    : "transport_company";

  transportCompanyCopy.transportCompanyRoutes?.forEach((route) => {
    delete route.createdAt;
    delete route.updatedAt;
    if (route?.logisticRoute) {
      delete (route as any).logisticRoute;
    }

    route.logisticRouteUuid =
      route?.logisticRouteUuid || route?.logisticRoute?.uuid;
    route.vehicleUuid = route?.vehicleUuid || route?.vehicle?.uuid;
    route.currency = isImporter ? "USD" : "MXN";
    route.type = isImporter ? "first_mile" : "last_mile";
  });

  return transportCompanyCopy;
};
